import html from '../legacy/c.html?raw';
import { LegacyHtmlPage } from './LegacyHtmlPage';

export function C() {
  return <LegacyHtmlPage slug="c" title="C Programming Language" html={html} />;
}
